import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import SEO from "../../Common/SEO";
import FullPageProgress from "../../FullPageProgress";
import { ToastManager } from "../../Toast/ToastManager";
import PostEditorView from "../Editor/PostEditorView";
import PostPreviewAnalytics from "./PostPreviewAnalytics";
import PostPreviewAuthor from "./PostPreviewAuthor";
import PostPreviewNav from "./PostPreviewNav";
import PostPreviewStatic from "./PostPreviewStatic";
import PostPreviewTitle from "./PostPreviewTitle";
import { SESSION_AUTH } from "../../../common/auth";
import { GET_READ_TIME, GET_TEXT_HTML } from "../../../common/utils";
import { POST_SERVICES } from "../../../services";
import "./style.scss";

const PostPreview = () => {
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const { urlSlug } = useParams();
  const [postDetail, setPostDetail] = useState("");
  const [loading, setLoading] = useState(true);
  const dataFetched = useRef(false);
  const [postSummary, setPostSummary] = useState("");
  const [readTime, setReadTime] = useState("");

  useEffect(() => {
    if (dataFetched.current || !urlSlug) return;
    dataFetched.current = true;
    setLoading(true);
    POST_SERVICES.detail({
      userId: isUserSession?.userId,
      org: isUserSession?.org?.id,
      urlSlug: urlSlug,
    })
      .then(data => {
        if (data.code === 200) {
          let summary = GET_TEXT_HTML(data?.data?.postBody);
          let rTime = GET_READ_TIME(summary);

          setPostSummary(summary);
          setReadTime(rTime);
          setPostDetail(data?.data);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({
            title: data?.message,
          });
        }
      })
      .catch(err => {
        ToastManager.addToast({
          title: err?.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [urlSlug, isUserSession, LOGOUT_USER_SESSION, dataFetched]);
  return loading ? (
    <FullPageProgress fixed={true} />
  ) : postDetail ? (
    <React.Fragment>
      <SEO
        title={postDetail?.postTitle}
        url={postDetail?.postLink}
        description={postSummary}
      />

      <div className="events6ix-layout-page-middle">
        <PostPreviewNav {...postDetail} />
        <PostPreviewStatic
          postTime={postDetail?.publishedAt}
          readTime={readTime}
          category={postDetail?.category}
          status={postDetail?.status}
        />
        <PostPreviewTitle postTitle={postDetail?.postTitle} />
        <PostPreviewAuthor author={postDetail?.author} />
        <PostPreviewAnalytics {...postDetail} />
        <div className="com-divider w-100"></div>
        <PostEditorView content={postDetail?.postBody} />
      </div>
    </React.Fragment>
  ) : (
    <FullPageProgress />
  );
};

export default PostPreview;
